import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { environment } from './../../../environments/environment';

export interface Select {
  key: string;
  name: string;
}
@Component({
  selector: 'custom-auto-complete',
  templateUrl: './custom-auto-complete.component.html',
  styleUrls: ['./custom-auto-complete.component.scss'],
})
export class CustomAutoCompleteComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;

  filteredOptions: string[];
  show: boolean;
  @Input() initialValue: String;
  isClearValueNotExisting: boolean;
  initValueOptional:string;
  isSeletedChange: boolean = false;
  optionalEle = [{value: 'NULL', label:'Choose an option'}];
  suggestionsForOption: any = [];
  @Input() label: string;
  @Input() placeholder: string;
  @Input() id: string;
  @Input() error:string;
  @Input() disabled: boolean;
  @Input() model;
  @Input() optional: boolean;
  @Input() multiple: boolean = false;
  @Input() arrayValue: any [];
  @Input() data: [];
  @Input() margin: string;
  @Input() format: string;
  @Input() isValidateValue: boolean = true;
  @Input() keyword = 'label';
  @Input() valueKeyword = 'id';
  @Input() value = '';
  @Input() isDisable: boolean;
  @Input() required: boolean = false;
  @Input() title = '';
  @Input() prefixIconSrc = '';
  @Input()
  suffixIconSrc = `${this.RESOURCE_SERVER_URL}/assets/images/auto-complete.svg`;
  @Input() suggestions: any = [];
  @Input() overlay = false;

  @Output() valueChange = new EventEmitter();
  @Output() selectedChange = new EventEmitter();
  @Output() clearOrSelectedChange = new EventEmitter();
  @Output() change = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @ViewChild('auto', { static: true }) auto;
  @ViewChild('outlet', { read: ViewContainerRef }) outletRef: ViewContainerRef;
  @ViewChild('content', { read: TemplateRef }) contentRef: TemplateRef<any>;

  controlledValue = '';



  constructor(private renderer: Renderer2, private el: ElementRef) {
  }

  ngOnInit(): void {
    this.show = true;
    this.initialValue;
    if(this.required == false){
      this.suggestionsForOption = this.optionalEle.concat(this.suggestions);
      if(this.initialValue == '') this.initialValue = 'NULL';
    }
  }

  onChanges(event) {
    console.log(event)
    this.initialValue = event.value;
    // if (event === '') this.initialValue = '';
    // if (event.value === 'NULL') this.initialValue = '';
    // if(event.value = ''){
    //   const collection = document.getElementsByClassName("selectedOption");
    //   collection[0].innerHTML = '';
    // }
    this.valueChange.emit(event.value === 'NULL' ? '' : event.value);
  }

  onBlur(event){
    this.blur.emit(event.value);
  }
}
